import React from 'react'
import { Alert, Card, CardBody, CardHeader, Button } from 'reactstrap'

function FormCard({
  title,
  onSubmit,
  onCancel,
  submitLabel = 'Guardar',
  cancelLabel = 'Cancelar',
  showCancel = false,
  isSubmitting = false,
  errorMessage = '',
  successMessage = '',
  children,
}) {
  return (
    <Card className="form-card">
      <CardHeader className="form-card-header">
        <h5>{title}</h5>
      </CardHeader>
      <CardBody className="form-card-body">
        {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
        {successMessage && <Alert color="success">{successMessage}</Alert>}
        <form onSubmit={onSubmit}>
          {children}
          <div className="button-group">
            <Button
              color="success"
              type="submit"
              className="btn-form btn-form-success"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Guardando...' : submitLabel}
            </Button>
            {showCancel && (
              <Button
                color="secondary"
                type="button"
                className="btn-form btn-form-secondary"
                onClick={onCancel}
                disabled={isSubmitting}
              >
                {cancelLabel}
              </Button>
            )}
          </div>
        </form>
      </CardBody>
    </Card>
  )
}

export default FormCard
